// extracted by mini-css-extract-plugin
module.exports = {"hasShakeAnimation":"ValidationInput_hasShakeAnimation__1_rxm","kf_shake":"ValidationInput_kf_shake__38GY-"};